export const solutionsData = [
    {
        imageUrl:"solutions/games.jpg",
        title:"Games",
        description:"Everything you need to create and operate your games."
    },
    {
        imageUrl:"solutions/automotive-real-time-3d-rendering.webp",
        title:'Automotive, Transportation & Manufacturing',
        description:'Gain a competitve edge with real-time 3D in a rapidly evolving industry landscape.'
    },
    {
        imageUrl:"solutions/film-animation.jpg",
        title:"Film, Animation & Cinematics",
        description: "Unprecedented artisitc freedom and faster production for film and animation projects."
    },
    {
        imageUrl:"solutions/architecture.webp",
        title:"Architecture, Engineering & Construction",
        description:"Create immersive 3D experiences for real-world applications at scale."
    },
    {
        imageUrl:"solutions/accelerate.jpg",
        title:"Accelerate Solutions for Enterprise",
        description:"Custo technology solutions from Unity that enable companies to innovate faster."
    },
    {
        imageUrl:"solutions/aerospace-government.jpg",
        title:"Government & Aerospace",
        description:"Explore Unity's simulation and training solutions for data visualization, 3D simulation, AI and machine learning training, and extended reality (AR, VR, MR)."
    },
    {
        imageUrl:"solutions/brands-agencies.webp",
        title:"Brands and Creative Agenies",
        description:"Create bleeding-edge experiences using the leading real-time 3D platform."
    },
    {
        imageUrl:"solutions/gambling.jpg",
        title:"Gambling",
        description:"Create rich gambling and casino games for land-based, online, and mobile with Unity's real-time gamee development platform."
    },
    {
        imageUrl:"solutions/learning-training.webp",
        title:"EdTech",
        description:"Create Games, simulations and VR/AR tools that improve users' skills, knowledge and performance."
    },
]